"use strict";
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.PriceVerifier__factory = void 0;
var ethers_1 = require("ethers");
var PriceVerifier__factory = /** @class */ (function (_super) {
    __extends(PriceVerifier__factory, _super);
    function PriceVerifier__factory(signer) {
        return _super.call(this, _abi, _bytecode, signer) || this;
    }
    PriceVerifier__factory.prototype.deploy = function (overrides) {
        return _super.prototype.deploy.call(this, overrides || {});
    };
    PriceVerifier__factory.prototype.getDeployTransaction = function (overrides) {
        return _super.prototype.getDeployTransaction.call(this, overrides || {});
    };
    PriceVerifier__factory.prototype.attach = function (address) {
        return _super.prototype.attach.call(this, address);
    };
    PriceVerifier__factory.prototype.connect = function (signer) {
        return _super.prototype.connect.call(this, signer);
    };
    PriceVerifier__factory.connect = function (address, signerOrProvider) {
        return new ethers_1.Contract(address, _abi, signerOrProvider);
    };
    return PriceVerifier__factory;
}(ethers_1.ContractFactory));
exports.PriceVerifier__factory = PriceVerifier__factory;
var _abi = [
    {
        inputs: [],
        name: "EIP712_DOMAIN_TYPEHASH",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
];
var _bytecode = "0x608060405234801561001057600080fd5b506101c3806100206000396000f3fe608060405234801561001057600080fd5b506004361061002b5760003560e01c8063c7977be714610030575b600080fd5b61003861004e565b60405161004591906100e7565b60405180910390f35b6040518060600160405280603881526020016101566038913960405160200161007791906100d0565b6040516020818303038152906040528051906020012081565b61009981610118565b82525050565b60006100aa82610102565b6100b4818561010d565b93506100c4818560208601610122565b80840191505092915050565b60006100dc828461009f565b915081905092915050565b60006020820190506100fc6000830184610090565b92915050565b600081519050919050565b600081905092915050565b6000819050919050565b60005b83811015610140578082015181840152602081019050610125565b8381111561014f576000848401525b5050505056fe454950373132446f6d61696e28737472696e67206e616d652c737472696e672076657273696f6e2c75696e7432353620636861696e496429a26469706673582212204f6fb07af2513db7bb68749e33ba23d580ea2d3e8ab3940b6ccb5e99740d266e64736f6c63430008040033";
//# sourceMappingURL=PriceVerifier__factory.js.map